<template>
  <b-field
    :label="getLabel"
    class="column"
    :class="getSizeColumn">
    <b-input
      v-if="property.type === constantes.TEXTE"
      v-model="value"
      :disabled="disabled"/>
    <qd-numberinput
      v-else-if="property.type === constantes.NOMBRE"
      v-model="value"
      :controls="false"
      :disabled="disabled"/>
    <b-checkbox
      v-else-if="property.type === constantes.OUI_NON"
      v-model="value"
      :disabled="disabled"/>
    <b-select v-else
      v-model="value"
      :disabled="disabled"
      expanded>
      <option></option>
      <option v-for="val in property.arrayValues"
        :key="val"
        :value="val">
        {{ val }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import {
  TEXTE,
  NOMBRE,
  OUI_NON,
  TABLEAU,
} from '@/configuration/jsonEditor/jsonEditorConfig';
import convertValue from '@/services/general/typeConverter';

export default {
  props: {
    property: {
      type: Object,
      required: true,
    },
    isModeEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      constantes: {
        TEXTE,
        NOMBRE,
        OUI_NON,
        TABLEAU,
      },
    };
  },
  computed: {
    value: {
      get() {
        return convertValue(this.property.defaultValue, this.property.type);
      },
      set(val) {
        this.property.defaultValue = val;
      },
    },
    getLabel() {
      if (this.isModeEdit) return this.$t('addEditNomenclatureType.ajoutChamp.valeurDefaut');
      return this.property.label;
    },
    getSizeColumn() {
      if (this.isModeEdit) return 'is-4';

      switch (this.property.type) {
        case this.constantes.TEXTE:
          return 'is-4';
        case this.constantes.NOMBRE:
        case this.constantes.OUI_NON:
          return 'is-2';
        case this.constantes.TABLEAU:
          return 'is-3';
        default:
          return 'is-4';
      }
    },
  },
};
</script>
